/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';

import RouteNames from '../../../RouteNames';
import * as selectors from '../../../redux/reduxSelectors';

import NavigationActions from '../../../redux/NavigationActions';
import { selectors as groupSelectors, actions as groupActions } from '../../../../redux/ducks/group';
import { userSelectors } from '../../../../redux/selectors_authorizedApp';

import GroupDetails from './GroupDetails';

function mapStateToProps(state, routerProps) {
  const history = routerProps.history;
  const profileId = selectors.getActiveProfileId(state);
  const profile = selectors.getActiveProfile(state);
  const groupId = Number(routerProps.match.params.groupId);
  const isLeaving = routerProps.location.pathname.indexOf('/leave') > -1;
  const group = groupSelectors.getGroup(state, groupId);
  const preferredLanguageCode = userSelectors.getPreferredLanguageCode(state);
  const isActiveGroup = groupSelectors.isActiveGroup(state, profileId, groupId);

  return {
    profile,
    profileId,
    groupId,
    group,
    isLeaving,
    preferredLanguageCode,
    isActiveGroup,
    isMainProfile: profileId === selectors.getMainProfileId(state),
    onCancel: () => {
      NavigationActions.goBackTo(history, RouteNames.groupInfo(groupId));
    },
    onGoBack: () => {
      NavigationActions.goBackTo(history, RouteNames.myGroups());
    },
    onGoToLeave: () => {
      NavigationActions.goBackTo(history, RouteNames.leaveGroup(groupId));
    },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setActiveGroup: (groupId) => {
      dispatch(groupActions.setActiveGroup(groupId));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupDetails);
